/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf
import { createIllustration } from '@jira/illustrations__illustration/src/ui/index.tsx';
import type {
	AsImgProps,
	IllustrationFn,
	SVGViewBox,
} from '@jira/illustrations__illustration/src/ui/types.tsx';
import srcDark from '../../assets/generic-empty-state-darkmode.svg';
import srcLight from '../../assets/generic-empty-state.svg';

const Illustration: IllustrationFn<AsImgProps> = createIllustration({
	srcLight,
	srcDark,
});

export default Illustration;

// for advanced use only
const viewBox: SVGViewBox = [0, 0, 235, 210];
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { srcLight, srcDark, viewBox };
